import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`
const SUGARCOACH_BASE_URL = `${process.env.REACT_APP_BACKEND_HOST}`

// 생성
export const createFastLane = async (payload) => {
  const res = await axios.post(`${baseUrl}/salus-work/fastlane`, payload)
  return res?.data
}

// 수정
export const updateFastLane = async (payload) => {
  const res = await axios.put(`${baseUrl}/salus-work/fastlane`, payload)
  return res?.data
}
// 완료 상태 변경
export const updateFastLaneStatus = async (workId) => {
  const res = await axios.put(
    `${baseUrl}/salus-work/fastlane/switch-complete/${workId}`,
  )
  return res?.data
}

// 삭제
export const deleteFastResponseWork = async (workId) => {
  const res = await axios.delete(`${baseUrl}/salus-work/fastlane/${workId}`)
  return res?.data
}

// 리스트
export const getFastLaneList = async (salusUserId, type) => {
  const res = await axios.get(`${baseUrl}/salus-work/single-work/list`, {
    params: { salusUserId, type: type },
  })
  return res?.data
}

// 상세
export const getFastLaneDetail = async (workId) => {
  const res = await axios.get(`${baseUrl}/salus-work/single-work/${workId}`)
  return res?.data
}

// --------------------------------
// --------------------------------
// --------------------------------
// --------------------------------

// Response 업무 생성
export const createResponseWork = async (payload) => {
  // {
  //   "title": "string",
  //   "dueDate": "2026-01-22T03:17:26.720Z",
  //   "salusUserId": 0
  // }
  const res = await axios.post(`${baseUrl}/salus-work/response-work`, payload)
  return res?.data
}

// Response 업무 수정
export const updateResponseWork = async (payload) => {
  // {
  //   "workId": 0,
  //   "title": "string",
  //   "dueDate": "2026-01-22T03:18:05.482Z",
  //   "isComplete": true
  // }
  const res = await axios.put(`${baseUrl}/salus-work/response-work`, payload)
  return res?.data
}

// Response 업무 완료 상태 변경
export const updateResponseWorkStatus = async (workId) => {
  const res = await axios.put(
    `${baseUrl}/salus-work/response-work/switch-complete/${workId}`,
  )
  return res?.data
}
